(function () {
  if (window.__pcLandingLoaded) return;
  window.__pcLandingLoaded = true;

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(
        cents,
        window.theme?.moneyFormat || "${{amount}}",
      );
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function parseCents(value) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : 0;
  }

  function packQtyLabel(label) {
    return (label || "").split("/")[0].trim();
  }

  function initOffer(section) {
    var packs = section.querySelectorAll("[data-pc-pack]");
    if (!packs.length) return;

    var qtyInput = section.querySelector("[data-pc-qty]");
    var minusBtn = section.querySelector("[data-pc-qty-minus]");
    var plusBtn = section.querySelector("[data-pc-qty-plus]");
    var buyTotal = section.querySelector("[data-pc-buy-total]");
    var variantInput = section.querySelector("[data-pc-variant-id]");
    var addBtn = section.querySelector("[data-pc-add-btn]");

    var state = {
      price: parseCents(section.dataset.defaultPrice),
      compare: parseCents(section.dataset.defaultCompare),
      variantId: section.dataset.defaultVariant || "",
      qty: 1,
      label: packQtyLabel(section.dataset.defaultLabel),
    };

    function render() {
      var total = state.price * state.qty;
      if (buyTotal) buyTotal.textContent = "Total: " + money(total);
      if (addBtn) addBtn.textContent = "Add to Cart — " + money(total);
      if (variantInput) variantInput.value = state.variantId;

      document
        .querySelectorAll("[data-pc-landing-price-now]")
        .forEach(function (el) {
          el.textContent = money(state.price);
        });
      document
        .querySelectorAll("[data-pc-landing-price-was]")
        .forEach(function (el) {
          el.textContent = money(state.compare);
        });
      document
        .querySelectorAll("[data-pc-landing-sticky-label]")
        .forEach(function (el) {
          el.textContent = el.dataset.baseLabel + " · " + state.label;
        });
      document
        .querySelectorAll("[data-pc-landing-sticky-price]")
        .forEach(function (el) {
          el.innerHTML =
            money(state.price) + " <s>" + money(state.compare) + "</s>";
        });
    }

    function selectPack(el) {
      packs.forEach(function (p) {
        p.classList.remove("sel");
        p.setAttribute("aria-pressed", "false");
      });
      el.classList.add("sel");
      el.setAttribute("aria-pressed", "true");
      state.price = parseCents(el.dataset.price);
      state.compare = parseCents(el.dataset.compare);
      state.variantId = el.dataset.variantId;
      state.label = packQtyLabel(el.dataset.packLabel);
      render();
    }

    packs.forEach(function (el) {
      el.addEventListener("click", function () {
        selectPack(el);
      });
      el.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          selectPack(el);
        }
      });
    });

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener("click", function () {
        state.qty = Math.min(10, state.qty + 1);
        qtyInput.value = state.qty;
        render();
      });
    }
    if (minusBtn && qtyInput) {
      minusBtn.addEventListener("click", function () {
        state.qty = Math.max(1, state.qty - 1);
        qtyInput.value = state.qty;
        render();
      });
    }

    if (addBtn && typeof window.addToCartRebuy === "function") {
      addBtn.addEventListener("click", function () {
        if (!state.variantId) return;
        window.addToCartRebuy(state.variantId, addBtn, state.qty);
      });
    }

    render();
  }

  function initGallery(section) {
    var track = section.querySelector("[data-pc-gallery-track]");
    var thumbs = section.querySelectorAll("[data-pc-gallery-thumb]");
    if (!track || !thumbs.length) return;

    var imgs = track.querySelectorAll("img");
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.getAttribute("data-idx"), 10);
        if (imgs[idx]) {
          imgs[idx].scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        }
        thumbs.forEach(function (b) {
          b.classList.remove("active");
        });
        btn.classList.add("active");
      });
    });

    var scrollTimer;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (b) {
          b.classList.remove("active");
        });
        if (thumbs[idx]) thumbs[idx].classList.add("active");
      }, 90);
    });
  }

  function initFaq(section) {
    section.querySelectorAll("[data-pc-faq-item]").forEach(function (qa) {
      var btn = qa.querySelector("button");
      var ans = qa.querySelector(".ans");
      if (!btn || !ans) return;
      btn.addEventListener("click", function () {
        var open = qa.classList.contains("open");
        section.querySelectorAll("[data-pc-faq-item]").forEach(function (o) {
          o.classList.remove("open");
          var a = o.querySelector(".ans");
          if (a) a.style.maxHeight = null;
        });
        if (!open) {
          qa.classList.add("open");
          ans.style.maxHeight = ans.scrollHeight + "px";
        }
      });
    });
  }

  function initScrollButtons() {
    document
      .querySelectorAll("[data-pc-scroll-target]")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          var id = btn.getAttribute("data-pc-scroll-target");
          var target = document.getElementById(id);
          if (target)
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });
  }

  function initSticky() {
    var sticky = document.querySelector("[data-pc-sticky]");
    var hero = document.querySelector("[data-pc-hero]");
    var offer = document.querySelector("[data-pc-offer]");
    if (!sticky || !hero || !offer) return;

    var stickyBtn = sticky.querySelector("[data-pc-sticky-add]");
    if (stickyBtn) {
      stickyBtn.addEventListener("click", function () {
        var addBtn = offer.querySelector("[data-pc-add-btn]");
        if (addBtn) {
          addBtn.click();
          return;
        }
      });
    }

    function updateSticky() {
      var y = window.scrollY || window.pageYOffset;
      var offerTop = offer.offsetTop;
      var offerBottom = offer.offsetTop + offer.offsetHeight;
      var vh = window.innerHeight;
      var inOffer = y + vh > offerTop && y < offerBottom;
      sticky.classList.toggle("show", !inOffer);
    }

    window.addEventListener("scroll", updateSticky, { passive: true });
    window.addEventListener("resize", updateSticky);
    updateSticky();
  }

  function initAll() {
    document.querySelectorAll("[data-pc-offer]").forEach(initOffer);
    document.querySelectorAll("[data-pc-gallery]").forEach(initGallery);
    document.querySelectorAll("[data-pc-faq]").forEach(initFaq);
    initScrollButtons();
    initSticky();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
